export default "__VITE_ASSET__870b951d__"